export default __webpack_public_path__ + "static/media/icon-info-participation-fees-4.dba359a6.svg";